// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

const updateCriteriaValidity = (state, action) => action.data;

export default (state = false, action) => {

    const actionTypes = {
        [actions.UPDATE_CRITERIA_VALIDITY]: updateCriteriaValidity
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/shared/reducers/is-criteria-valid.js